<template>
  <div class="register absolute">
    <div class="register_tit">
      <img @click="$router.go(-1)" src="../../assets/images/licai/fanhui.png" />
      <p class="">{{ $t("m.jf_span11") }}</p>
    </div>
    <div class="register_block">
      <div
        style="border-radius:8px;background:#fff;padding:0px 10px 25px 10px;font-size:14px;"
      >
        <div
          class="pay-row"
        >
          <span class="pay-label">{{
            $t("m.jf_span12")
          }}</span>
          <input type="text" v-model="name" maxlength="20" placeholder="请输入收货人姓名" />
        </div>
        <div
          class="pay-row"
        >
          <span class="pay-label">{{
            $t("m.jf_span13")
          }}</span>
          <input type="tel" v-model="phone" maxlength="11" @input="onPhoneInput" placeholder="请输入11位手机号" />
        </div>
        <div
          class="pay-row"
          @click="diquBtn()"
        >
          <span class="pay-label">{{
            $t("m.jf_span14")
          }}</span>
          <input type="text" v-model="diqu" readonly placeholder="请选择所在地区" />
        </div>
        <div
          class="pay-row"
        >
          <span class="pay-label">{{
            $t("m.jf_span15")
          }}</span>
          <input type="text" v-model="address" maxlength="80" placeholder="请输入详细地址" />
        </div>
        <!-- <div style="height: 44px;line-height:44px;border-radius:22px;margin-top:20px; background:#FF4D33;color:#fff;font-weight:blod;font-size:17px;text-align:center;">保存地址</div> -->
      </div>

      <!-- <div style="border-radius:8px;background:#fff;padding:15px 10px 15px 15px;display:flex;align-items:center;position: relative;">
            <span style="position: absolute;right:10px;top:10px;color:#666;font-size:14px;">编辑</span>
            <div style="flex:1;margin-right:10px;">
                <div style="display:flex;align-items:center;">
                    <span style="color:#000;font-weight:bold;font-size:18px;margin-right:10px;">姚小帅</span>
                    <span style="color:#666;font-size:13px;">17681552082</span>
                </div>
                    <p style="margin-top:10px;font-size:14px;color:#000;">四川省陕西是农业由司法部思考，00000四川省陕西是农业由司法部思考，00000四川省陕西是农业由司法部思考，00000</p>
            </div>
            <img src="../../assets/images/licai/right.png" style="width: 20px;height: 20px;" alt="">
         </div> -->
      <div
        style="border-radius:8px;background:#fff;padding:10px 10px 50px 10px;margin-top:10px;"
      >
        <div
          style="font-size:20px;line-height:30px;color:#000;margin-bottom:10px;"
        >
          {{ $t("m.jf_span16") }}
        </div>
        <div style="display:flex;">
          <img
            :src="dicdata1.images"
            style="width: 100px;height: 100px;border-radius:8px;margin-right:10px;"
            alt=""
          />
          <div style="position: relative;flex:1;">
            <div style="font-size:17px;color:#000;" class="line-clamp2">
              {{ dicdata1.title }}
            </div>
            <div
              style="position: absolute;left:0px;bottom:0px;color:#666;font-size:13px;"
            >
              <span style="font-size:20px;color:red;font-weight:bold;"
                >{{ dicdata1.price }} </span
              >黄金碎片
            </div>
          </div>
        </div>
        <div
          style="display:flex;align-items:center;font-size:14px;margin-top:20px;"
        >
          <span style="width: 105px;color:#000;">{{ $t("m.jf_span5") }}</span>
          <span style="color:#666">{{ dicdata1.sketch }}</span>
        </div>
        <div
          style="display:flex;align-items:center;font-size:14px;height: 40px;"
        >
          <span style="width: 105px;color:#000;">{{ $t("m.jf_span6") }}</span>
          <span style="color:#666">{{ dicdata.num }}</span>
        </div>
        <div style="display:flex;align-items:center;font-size:14px;">
          <span style="width: 105px;color:#000;">{{ $t("m.jf_span7") }}</span>
          <span style="color:#666;flex:1;">{{ dicdata.bz }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="show"
      style="z-index: 1000; background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;"
    >
      <van-area
        style="position: absolute;left: 0;width: 100%;bottom: 0;"
        @cancel="cancel"
        @confirm="confirm"
        :title="$t('m.jf_span14')"
        :area-list="areaList"
      />
    </div>
    <div
      @click="wancheng"
      style="border-radius:4px 4px 0 0; width: 100%;position: fixed;bottom:0;left:0;height: 54px;line-height:54px; background:#FF4D33;color:#fff;font-weight:blod;font-size:17px;text-align:center;"
    >
      {{ submitting ? "提交中..." : $t("m.tijiao") }}
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { goodsImage } from "@utils/goodsImage";
import { areaList } from "@vant/area-data";
export default {
  name: "JfPay",
  data: function() {
    return {
      show: false,
      areaList: areaList,
      diqu: "",
      name: "",
      phone: "",
      address: "",
      money: "",
      mima: "",
      submitting: false,
      dicdata: {},
      dicdata1: {}
    };
  },

  mounted: function() {
    this.dicdata = JSON.parse(localStorage.getItem("jifen"));

    let type = this.$route.params.id;
    request
      .get("/shop/goods/good-detail", { id: type }, { login: true })
      .then(res => {
        console.log(res);
        const data = res.data.data || {};
        data.images = goodsImage(data.images);
        this.dicdata1 = data;
      })
      .catch(err => {
        this.$dialog.fromError(err, "加载失败");
      });
  },
  methods: {
    confirm(e) {
      console.log(e);
      this.diqu = e[0].name + e[1].name + e[2].name;
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
    diquBtn() {
      this.show = true;
    },
    onPhoneInput() {
      this.phone = String(this.phone || "").replace(/\D/g, "").slice(0, 11);
    },
    wancheng() {
      if (this.submitting) {
        return;
      }
      const name = String(this.name || "").trim();
      const phone = String(this.phone || "").replace(/\s+/g, "");
      const diqu = String(this.diqu || "").trim();
      const address = String(this.address || "").trim();
      if (!name) {
        this.$dialog.error("请填写收货人姓名");
        return;
      }
      if (name.length > 20) {
        this.$dialog.error("收货人姓名过长");
        return;
      }
      if (!phone) {
        this.$dialog.error("请填写联系电话");
        return;
      }
      if (!/^1\d{10}$/.test(phone)) {
        this.$dialog.error("请填写11位手机号码");
        return;
      }
      if (!diqu) {
        this.$dialog.error("请选择所在地区");
        return;
      }
      if (!address) {
        this.$dialog.error("请填写详细地址");
        return;
      }
      this.dicdata.name = name;
      this.dicdata.phone = phone;
      this.dicdata.address = address;
      this.dicdata.diqu = diqu;
      localStorage.setItem("jifen", JSON.stringify(this.dicdata));

      let type = this.$route.params.id;
      this.submitting = true;
      request
        .post(
          "/shop/goods/add",
          {
            id: type,
            num: this.dicdata.num,
            phone: phone,
            name: name,
            address: diqu + address
          },
          { login: true }
        )
        .then(res => {
          this.submitting = false;
          const code = res.data && res.data.code;
          if (code && Number(code) !== 200) {
            this.$dialog.error((res.data && res.data.msg) || "兑换失败");
            return;
          }
          this.$router.push({
            path: "/JfOver/" + type
          });
        })
        .catch(err => {
          this.submitting = false;
          const msg =
            (err &&
              err.response &&
              err.response.data &&
              err.response.data.msg) ||
            "兑换失败，请检查填写信息";
          this.$dialog.error(msg);
        });
    }
  }
};
</script>
<style scoped>
.pay-row {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  height: 45px;
}
.pay-label {
  width: 100px;
  flex-shrink: 0;
  font-weight: bold;
  color: #000;
}
.pay-row input {
  flex: 1;
  min-width: 0;
  text-align: right;
  border: 0;
  background: transparent;
  outline: none;
}
.line-clamp2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.register_block {
  padding: 10px;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>
